import { Dispatch } from 'redux';
import { fetcher } from '../../lib/request';

export const GET_OPENED_COUNTRIES_REQUEST = 'GET_OPENED_COUNTRIES_REQUEST';
export const GET_OPENED_COUNTRIES_RESPONSE = 'GET_OPENED_COUNTRIES_RESPONSE';
export const GET_OPENED_COUNTRIES_ERROR = 'GET_OPENED_COUNTRIES_ERROR';

const OPENED_COUNTRIES_HOST = process.env.REACT_APP_OPENED_COUNTRIES_HOST;
const OPENED_COUNTRIES_KEY = process.env.REACT_APP_OPENED_COUNTRIES_KEY;

export const getOpenedCountriesAction = (filters: string, q?: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_OPENED_COUNTRIES_REQUEST,
        filters,
        q
    });

    try {
        const response = await fetcher(`${OPENED_COUNTRIES_HOST}/client/v1/countries?filters[]=${filters}${q ? `&q=${q}` : ''}`)
            .auth(`Basic ${OPENED_COUNTRIES_KEY}`)
            .json();

        dispatch({
            type: GET_OPENED_COUNTRIES_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_OPENED_COUNTRIES_ERROR,
            error
        });
    }
};



// WEBPACK FOOTER //
// ./src/actions/OpenedCountries/openedCountries.ts